import React, { useEffect } from 'react';
import Dialog from 'src/components/common/Dialog';
import Button from 'src/components/controls/forms/redesign/FormButton';
import { useForm } from 'react-hook-form';
// import { useDispatch } from 'react-redux';
// import actions from 'src/actions';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import Vendor from 'src/models/AP/Vendor';
import _ from 'lodash';
// import DialogList from 'src/dialogs';

interface IFindVendorDialogProps {
    dialogName: string;
    hideDialog: () => void;
    onCancel?: () => void;
    resetVendorSearchOptions?: () => void;
    setVendorSearchTerm?: (keyword: string) => void;
    incrementVendors?: () => void;
    vendors: Vendor[];
    showAddVendorDialog?: () => void;
    setSelectedVendor?: (vendorNumber: number) => void;
}

/* const vendors = [
    { id: 1, vendorNumber: 4934, vendorName: 'American Abstract LLC', address: '2019 Galisteo Street, Suite G-3', city: 'Santa Fe', state: 'New Mexico' },
    { id: 2, vendorNumber: 4934, vendorName: 'American Abstract LLC', address: '2019 Galisteo Street, Suite G-3', city: 'Santa Fe', state: 'New Mexico' },
    { id: 3, vendorNumber: 4934, vendorName: 'American Abstract LLC', address: '2019 Galisteo Street, Suite G-3', city: 'Santa Fe', state: 'New Mexico' },
    { id: 4, vendorNumber: 4934, vendorName: 'American Abstract LLC', address: '2019 Galisteo Street, Suite G-3', city: 'Santa Fe', state: 'New Mexico' },
]; */

const FindVendorDialog = (props: IFindVendorDialogProps) => {
    const { register, errors, getValues } = useForm();
    // const dispatch = useDispatch();

    useEffect(() => {
        onCreate();
    }, []);

    const onCreate = () => {
        console.log('FindVendorDialog onCreate()');
    };

/*     const showDialog = (dialog: DialogList) => {
        dispatch(actions.layout.showDialog(dialog));
    }; */

    const OKClicked = () => {
        props.hideDialog();
    };

    const onVendorSearchChanged = (searchContent: string) => {
        search();
    };

    const showAddVendorDialog = () => {
        props.showAddVendorDialog();
    };

    const getScrollStatus = (divElement: HTMLDivElement) => {
        if (divElement) {
            const scrollTop = divElement.scrollTop % 1 > .9 ? divElement.scrollTop : Math.round(divElement.scrollTop);
            const scrollHeight = divElement.scrollHeight;
            const clientHeight = divElement.clientHeight;

            // Check if reached the end of the list
            if (scrollTop + clientHeight >= scrollHeight) {
                props.incrementVendors();
                console.log('end of scroll YES');
            } else {
                console.log('end of scroll NO');
            }
        }
    };

    const search = _.debounce(() => {
        let searchName = getValues()?.search;
        props.setVendorSearchTerm(searchName);
        // props.resetVendorSearchOptions();
    }, 800);

    return (
        <>
        <Dialog title="Find Vendor" dialogName={props.dialogName} isExitButtonInvisible={true} bodyStyle={{ width: '50%' }}>
        <form>
            <div className="form-row" style={{marginTop: '1rem'}}>
                <RHFInputBox
                    onChange={(event) => onVendorSearchChanged(event.currentTarget.value)}
                    labelOnLeft={true}
                    label="Enter Vendor Name"
                    name={'search'}
                    style={{width: '70%'}}
                    register={register}
                />
                <Button className="blue-hover-button" style={{ width: '30%', height: '3rem', marginRight: '3rem', justifyContent: 'center'}} text={'Add Vendor'} onClick={() => showAddVendorDialog()}/>
            </div>
            <div onScroll={(event) => getScrollStatus(event.currentTarget)} style={{marginTop: '3rem', overflowY: 'auto', maxHeight: '500px'}}>
                
                    <table>
                        <thead style={{ textAlign: 'left' }}>
                            <tr>
                                <th>#</th>
                                <th>Name</th>
                                <th>Address</th>
                                <th>City</th>
                                <th>State</th>
                            </tr>
                        </thead>
                        <tbody>
                        {props?.vendors?.map((vendor: Vendor, index: number) => {
                            return (
                                    // tslint:disable-next-line
                                    <tr key={vendor.vendorNumber + index} onDoubleClick={() => {props.setSelectedVendor(index); OKClicked();}} onClick={() => props.setSelectedVendor(index) } className="table-item-hover" style={{ textAlign: 'left' }}>
                                        <td style={{ width: '7%' }}>
                                            <RHFInputBox
                                                name={`vendors[${index}].vendorNumber`}
                                                type="text"
                                                defaultVal={vendor.vendorNumber + ''}
                                                register={register}
                                                errors={errors}
                                                style={{ width: '100%' }}
                                                bodyStyle={{ width: '100%' }}
                                            />
                                        </td>
                                        <td style={{ width: '30%' }}>
                                            <RHFInputBox
                                                name={`vendors[${index}].vendorName`}
                                                type="text"
                                                defaultVal={vendor.vendorName}
                                                register={register}
                                                errors={errors}
                                                style={{ width: '100%' }}
                                                bodyStyle={{ width: '100%' }}
                                            />
                                        </td>
                                        <td style={{ width: '32%' }}>
                                            <RHFInputBox
                                                name={`vendors[${index}].address`}
                                                type="text"
                                                defaultVal={vendor.address}
                                                register={register}
                                                errors={errors}
                                                style={{ width: '100%' }}
                                                bodyStyle={{ width: '100%' }}
                                            />
                                        </td>
                                        <td style={{ width: '15%' }}>
                                            <RHFInputBox
                                                name={`vendors[${index}].city`}
                                                type="text"
                                                defaultVal={vendor.city}
                                                register={register}
                                                errors={errors}
                                                style={{ width: '100%' }}
                                                bodyStyle={{ width: '100%' }}
                                            />
                                        </td>
                                        <td style={{ width: '15%' }}>
                                            <RHFInputBox
                                                name={`vendors[${index}].state`}
                                                type="text"
                                                defaultVal={vendor.state}
                                                register={register}
                                                errors={errors}
                                                style={{ width: '100%' }}
                                                bodyStyle={{ width: '100%' }}
                                            />
                                        </td>
                                    </tr>
                                );
                            })}
                            </tbody>
                    </table>
                </div>
            </form>
            <div className="form-row" style={{marginTop: '2rem', marginLeft: '33%', textAlign: 'center'}}>
                <Button
                    className="blue-hover-button"
                    style={{ width: '24%', marginRight: '1rem' }}
                    text={'OK'}
                    onClick={() => OKClicked()}
                />
                <Button
                    className="blue-hover-button"
                    style={{ width: '24%', marginRight: '1rem' }}
                    text={'Cancel'}
                    onClick={() => props.onCancel()}
                />
            </div>
        </Dialog>
        </>
    );
};

export default FindVendorDialog;



// WEBPACK FOOTER //
// ./src/components/accounts-payable/dialogs/FindVendorDialog.tsx